import { NgModule } from '@angular/core';
import { AlertComponent } from './alert.component';

import { AlertExtendedDirective } from './directives/alert-extended.directive';
export { type AlertTypes, type AlertSizes, type AlertActionButtonTypes } from './alert.component';

@NgModule({
  exports: [AlertComponent, AlertExtendedDirective],
  imports: [AlertComponent, AlertExtendedDirective],
})
export class GalaxyAlertModule {}
